import CheckoutCustomTaxExemptStatusReducer from "@sunSource/Store/Data/CheckoutCustomTaxExemptStatus/CheckoutCustomTaxExemptStatusReducer";
import OnePageCheckoutCustomNotesReducer from "@sunSource/Store/Data/OnePageCheckoutCustomNotes/OnePageCheckoutCustomNotesReducer";
import { combineReducers } from "redux";

const customReducers = {
    OnePageCheckoutCustomNotes: OnePageCheckoutCustomNotesReducer,
    CheckoutCustomTaxExemptStatus: CheckoutCustomTaxExemptStatusReducer,
};

export type CustomDataReducers = typeof customReducers;

const customDataReducer = combineReducers(customReducers as any);

export default customDataReducer;
